<template>
    <div>
        <v-offline
                online-class="online"
                offline-class="offline"
                @detected-condition="amIOnline">
            <template v-slot:[onlineSlot] :slot-name="onlineSlot">
                {{ onlineOfflineMsg }}
            </template>
            <template v-slot:[offlineSlot] :slot-name="offlineSlot">
                {{ onlineOfflineMsg }}
            </template>
        </v-offline>
        <div class="row">
            <div class="col-lg-12">
                <div>
                    <div class="row">
                        <div class="col-lg-12">
                            <div class="ibox ">
                                <div class="ibox-content">
                                    <div class="panel-heading">
                                        <h2 class="set_font_title">Edit Catch-Release Area</h2>
                                        <p></p>
                                    </div>
                                    <div class="card setShadow" style="padding: 10px;">
                                        <div class="row">
                                            <div class="col col-sm-12">
                                                <p>
                                                    To edit a Vaccination Area (geofence) simply re-draw the new
                                                    geofence and press Save. The old geofence will be replaced with the
                                                    new one. Alternatively, upload a new one.
                                                </p>
                                                <p>
                                                    <b>Note</b>: Any out-of-area records will remain out-of-area even if now
                                                    within the new geofence border unless they are moved in.
                                                </p>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="panel-options col-md-8">
                                                <p>
                                                    Enter a search term or zoom/position the map to a particular area,
                                                    then draw a polygon.<br>
                                                    To add more vaccination areas(polygons), Click on the polygon icon.
                                                </p>
                                            </div>
                                            <div class="col col-md-4 text-right up_kml_btn">
                                                <button v-bind:disabled="!onLine" @click="uploadVaccinationArea"
                                                        class="btn btn-warning"
                                                        type="button" onclick="">
                                                    UPLOAD GEOFENCE (KML)
                                                </button>
                                            </div>
                                        </div>
                                        <div class="panel-body set_map">
                                            <MapBase
                                                v-if="project"
                                                :enableDraw="true"
                                                :enableKml="true"
                                                :enableSearch="true"
                                                :kmlFiles="kmlFiles"
                                                :center="mapCenter"
                                                :zoom="7"
                                                @shape-drawn="onDraw"
                                                @shapes-updated="onDraw"
                                            />
                                            
                                            <div v-if="!isLocationConfirmed && selectedLocation" class="mt-3">
                                                <p>Is selected Location confirmed?</p>
                                                <el-button @click="fetchLocality" :loading="loadingLocation" type="primary">
                                                    Yes
                                                </el-button>
                                                <el-button @click="selectedLocation = null;" type="info">
                                                    No
                                                </el-button>
                                            </div>

                                            <form @submit.prevent="submit" class="form-horizontal mt-3" :hidden="!isLocationConfirmed">
                                                <div class="row fence-fields">
                                                    <div class="col-sm-12 col-md-3">
                                                        <label>Vaccination Area Name <span class="error">*</span></label>
                                                        <input class="form-control" v-model="areaName" required>
                                                    </div>
                                                    <div class="col-sm-12 col-md-3">
                                                        <label>Country <span class="error">*</span></label>
                                                        <input class="form-control" v-model="areaCountry" required>
                                                    </div>
                                                    <div class="col-sm-12 col-md-3">
                                                        <label>State/Province<span class="error">*</span></label>
                                                        <input class="form-control" v-model="stateProvince" required>
                                                    </div>
                                                    <div class="col-sm-12 col-md-3">
                                                        <label>City/District/Village <span class="error">*</span></label>
                                                        <input class="form-control" v-model="cityDistrictVillage" required>
                                                    </div>
                                                </div>
                                                <div class="form-group mt-3" id="vaccination-areas-btn">
                                                    <div class="col-sm-12 text-right">
                                                        <button class="btn btn-white" type="button"
                                                                @click="goBack">Cancel
                                                        </button>
                                                        <button v-if="onLine" type="submit"
                                                                :disabled="isUploadingKMLData"
                                                                class="btn btn-primary">Save
                                                        </button>
                                                        <button v-else v-bind:disabled="true" type="submit"
                                                                class="btn btn-primary">Save
                                                        </button>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import mixin from '../../../mixins/GlobalMixin';
import {Select, Option, Button} from 'element-ui';
import VOffline from 'v-offline';
import MapBase from '../../map/MapBase.vue';

export default {
    components: {
        [Option.name]: Option,
        [Select.name]: Select,
        [Button.name]: Button,
        VOffline,
        MapBase
    },
    props: {
        areaId: {
            type: [Number, String],
        }
    },
    data()
    {
        return {
            polygonstyles: [],
            project: null,
            isUploadingKMLData: false,
            areaDetails: '',
            kmlFiles: [],
            mapCenter: {},
            generatedKml: null,
            selectedLocation: null,
            isLocationConfirmed: true, // Initially true for existing area
            loadingLocation: false,
            areaName: "",
            areaCountry: "",
            stateProvince: "",
            cityDistrictVillage: "",
        }
    },
    mixins: [mixin],
    methods: {
        submit()
        {
            let vm = this;
            vm.isUploadingKMLData = true;
            let areaId = vm.areaDetails.id;
            let requestPayload = {
                name: vm.areaName,
                country: vm.areaCountry,
                google_admin_area_level1: vm.stateProvince,
                google_locality: vm.cityDistrictVillage,
            }

            if (vm.generatedKml) {
                Object.assign(requestPayload, {kml_data: vm.generatedKml});
            }

            axios.put('/area/update/' + areaId, requestPayload).then(response => {
                if (response.data.response.error.error_code == 0) {
                    this.showAlert('Success', response.data.response.error.msg, true);
                    vm.isUploadingKMLData = false;
                    vm.getAreaDetails(areaId);
                    window.location.reload();
                } else {
                    this.showAlert('Error', response.data.response.error.msg, false);
                    vm.isUploadingKMLData = false;
                }
            }).catch(error => {
                this.showAlert('Error', error.response.data.response.error.error_msg, false);
                vm.isUploadingKMLData = false;
            });
        },
        logCode2(newShape)
        {
            let vm = this;
            let code = "";
            let kmltext1 = '<Placemark><name>' + 'name of geofence' + '</name>\n' +
                '<description>' + 'Description' + '</description>\n' +
                '<styleUrl>#' + 'poly-01579B-6-0-nodesc' + '</styleUrl>\n' +
                '<Polygon>\n<tessellate>' + '1' + '</tessellate>\n' +
                '<outerBoundaryIs><LinearRing><coordinates>\n';

            code = newShape
                .map(([lng, lat]) => `${lng},${lat},0.0`)
                .join(' \n') + ' \n';

            let kmltext2 = '</coordinates></LinearRing></outerBoundaryIs>\n</Polygon>\n</Placemark>\n';
            let generatedKml = vm.kmlheading(newShape) + kmltext1 + code + kmltext2 + vm.kmlend();
            vm.generatedKml = generatedKml;
        },
        kmlheading(newShape)
        {
            let vm = this;
            let heading = "";
            let styleforpolygon = "";
            let i;
            heading = '<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n' +
                '<kml xmlns="http://www.opengis.net/kml/2.2">\n' +
                '<Document><name>' + 'Untitled layer' + '</name>\n' +
                '<description>' + 'layer description' + '</description>\n';

            for (i = 0; i < newShape.length; i++) {
                styleforpolygon += '<Style id="' + vm.polygonstyles[0].name + '">\n' +
                    '<LineStyle><color>' + vm.polygonstyles[0].kmlcolor + '</color><width>' + vm.polygonstyles[0].width + '</width></LineStyle>\n' +
                    '<PolyStyle><color>' + vm.polygonstyles[0].kmlfill + '</color></PolyStyle>\n' +
                    '</Style>\n';
            }
            return heading + styleforpolygon;
        },
        kmlend()
        {
            let ending;
            return ending = '</Document>\n</kml>';
        },
        createpolygonstyleobject()
        {
            let vm = this;
            let polygonstyle = {
                name: "Lump",
                kmlcolor: "CD0000FF",
                kmlfill: "9AFF0000",
                color: "#FF0000",
                fill: "#0000FF",
                width: 2,
                lineopac: 0.8,
                fillopac: 0.6,
            };
            vm.polygonstyles.push(polygonstyle);
        },
        uploadVaccinationArea()
        {
            this.$router.push({name: 'uploadAreaKmlPm', params: {areaId: this.areaId}})
        },
        getAreaDetails(areaId)
        {
            axios.get("/area/details/" + areaId)
                .then(response => {
                    if (response.data.response.error.error_code == 0) {
                        let vm = this;
                        vm.areaDetails = response.data.response.data.area;
                        vm.areaName = vm.areaDetails.name;
                        vm.areaCountry = vm.areaDetails.google_country;
                        vm.stateProvince = vm.areaDetails.google_admin_area_level1;
                        vm.cityDistrictVillage = vm.areaDetails.google_locality;
                        
                        if (vm.areaDetails.file_url) {
                            vm.kmlFiles = [vm.addRegionToS3Host(vm.areaDetails.file_url, 'us-east-1')];
                        }
                    }
                })
                .catch(error => {
                    console.error("Failed to get area details", error);
                });
        },
        onDraw(shape) {
            this.logCode2(shape.geometry.coordinates[0]);
            if (shape.geometry.coordinates[0]) {
                const latLon = {
                    x: shape.geometry.coordinates[0][0][0],
                    y: shape.geometry.coordinates[0][0][1],
                };
                this.onAddressPicked(latLon);
            }
        },
        addRegionToS3Host(url, region = 'ap-south-1') {
            return url.replace('.s3.amazonaws.com', `.s3.${region}.amazonaws.com`);
        },
        onAddressPicked(address) {
            this.selectedLocation = address;
            this.isLocationConfirmed = false;
        },
        async fetchLocality() {
            const vm = this;
            try {
                vm.loadingLocation = true;
                const res = await fetch(
                    `https://nominatim.openstreetmap.org/reverse?format=geocodejson&lat=${this.selectedLocation.y}&lon=${this.selectedLocation.x}`,
                    {
                        headers: { "User-Agent": "App/1.0" }
                    }
                );
                const data = await res.json();

                const feature = data && data.features && data.features.length > 0 ? data.features[0] : null;
                const props = feature && feature.properties ? feature.properties : {};
                const addr = props.geocoding ? props.geocoding : {};

                vm.areaCountry = addr.country || null;
                vm.stateProvince = addr.state || null;
                vm.cityDistrictVillage = addr.district || addr.county || addr.city || addr.town || addr.village || null;

                vm.loadingLocation = false;
                vm.isLocationConfirmed = true;
            } catch (e) {
                console.error("Reverse geocode failed:", e);
                vm.loadingLocation = false;
                return null;
            }
        },
        goBack()
        {
            window.history.back();
        }
    },
    mounted()
    {
        let vm = this;
        vm.project = vm.$store.getters.getCurrentSelectedProject;
        if (vm.project && vm.project.project_location_lat_lng) {
            let latLng = vm.project.project_location_lat_lng.split(',');
            vm.mapCenter = {
                lat: +latLng[0],
                lng: +latLng[1]
            };
        }

        let url = location.href;
        let res = url.split("/");
        let areaId = res[res.length - 1];
        vm.getAreaDetails(areaId);
        vm.createpolygonstyleobject();
    }
}

</script>
<style scoped>
.pac-card {
    margin: 10px 10px 0 0;
    border-radius: 2px 0 0 2px;
    box-sizing: border-box;
    -moz-box-sizing: border-box;
    outline: none;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
    background-color: #fff;
}

.set_font_title {
    font-size: 15px;
    font-weight: 600;
    color: black;
    margin-left: -12px !important;
}

.set_map {
    margin-top: -17px;
    margin-bottom: -10px;
}

.up_kml_btn {
    margin-top: -10px;
    margin-bottom: 20px;
}

.fence-fields {
    padding-bottom: 0px !important;
    padding-top: 5px;
}

.set_cursor {
    cursor: pointer;
}
</style>
